

'use strict';
var frCity= [
        {
            "S": "亚洲",
            "Order": 1,
            "Items": [
                {
                    "I": "EAN_6056197",
                    "S": "清迈",
                    "Order": 1
                },
                {
                    "I": "EAN_6046393",
                    "S": "普吉岛",
                    "Order": 2
                },
                {
                    "I": "EAN_178236",
                    "S": "曼谷",
                    "Order": 3
                },
                {
                    "I": "EAN_602651",
                    "S": "巴厘岛",
                    "Order": 4
                },
                {
                    "I": "EAN_178308",
                    "S": "首尔",
                    "Order": 5
                },
                {
                    "I": "EAN_3168",
                    "S": "新加坡",
                    "Order": 6
                },
                {
                    "I": "EAN_109",
                    "S": "马尔代夫",
                    "Order": 7
                },
                {
                    "I": "EAN_3657",
                    "S": "苏梅岛",
                    "Order": 8
                },
                {
                    "I": "EAN_6131486",
                    "S": "京都",
                    "Order": 9
                },
                {
                    "I": "EAN_179900",
                    "S": "东京",
                    "Order": 10
                },
                {
                    "I": "EAN_601371",
                    "S": "长滩岛",
                    "Order": 11
                },
                {
                    "I": "EAN_179897",
                    "S": "大阪",
                    "Order": 12
                },
                {
                    "I": "EAN_850",
                    "S": "济州岛",
                    "Order": 13
                },
                {
                    "I": "EAN_6048149",
                    "S": "北海道",
                    "Order": 14
                },
                {
                    "I": "EAN_602231",
                    "S": "甲米府",
                    "Order": 15
                },
                {
                    "I": "EAN_2975",
                    "S": "暹粒",
                    "Order": 16
                },
                {
                    "I": "EAN_180008",
                    "S": "吉隆坡",
                    "Order": 17
                },
                {
                    "I": "EAN_167",
                    "S": "斯里兰卡",
                    "Order": 18
                },
                {
                    "I": "EAN_6126505",
                    "S": "兰卡威",
                    "Order": 19
                },
                {
                    "I": "EAN_10805",
                    "S": "冲绳",
                    "Order": 20
                },
                {
                    "I": "EAN_602",
                    "S": "亚庇",
                    "Order": 21
                },
                {
                    "I": "EAN_11188",
                    "S": "沙巴",
                    "Order": 22
                },
                {
                    "I": "EAN_6049558",
                    "S": "华欣",
                    "Order": 23
                },
                {
                    "I": "EAN_6128315",
                    "S": "箱根町",
                    "Order": 24
                },
                {
                    "I": "EAN_180030",
                    "S": "台北",
                    "Order": 25
                },
                {
                    "I": "EAN_553248635976007544",
                    "S": "垦丁",
                    "Order": 26
                },
                {
                    "I": "EAN_6178472",
                    "S": "花莲",
                    "Order": 27
                },
                {
                    "I": "EAN_6177725",
                    "S": "高雄",
                    "Order": 28
                }
            ]
        },
        {
            "S": "美洲",
            "Order": 2,
            "Items": [
                {
                    "I": "EAN_178293",
                    "S": "纽约",
                    "Order": 1
                },
                {
                    "I": "EAN_178280",
                    "S": "洛杉矶",
                    "Order": 2
                },
                {
                    "I": "EAN_178305",
                    "S": "旧金山",
                    "Order": 3
                },
                {
                    "I": "EAN_178276",
                    "S": "拉斯维加斯",
                    "Order": 4
                },
                {
                    "I": "EAN_213",
                    "S": "夏威夷",
                    "Order": 5
                },
                {
                    "I": "EAN_178315",
                    "S": "温哥华",
                    "Order": 6
                },
                {
                    "I": "EAN_178307",
                    "S": "西雅图",
                    "Order": 7
                },
                {
                    "I": "EAN_178239",
                    "S": "波士顿",
                    "Order": 8
                },
                {
                    "I": "EAN_178298",
                    "S": "菲尼克斯",
                    "Order": 9
                },
                {
                    "I": "EAN_178314",
                    "S": "多伦多",
                    "Order": 10
                },
                {
                    "I": "EAN_178248",
                    "S": "芝加哥",
                    "Order": 11
                },
                {
                    "I": "EAN_1488",
                    "S": "檀香山",
                    "Order": 12
                },
                {
                    "I": "EAN_3073",
                    "S": "圣地亚哥",
                    "Order": 13
                },
                {
                    "I": "EAN_178318",
                    "S": "华盛顿",
                    "Order": 14
                },
                {
                    "I": "EAN_178286",
                    "S": "迈阿密",
                    "Order": 15
                },
                {
                    "I": "EAN_178294",
                    "S": "奥兰多",
                    "Order": 16
                },
                {
                    "I": "EAN_178302",
                    "S": "盐湖城",
                    "Order": 17
                },
                {
                    "I": "EAN_6140738",
                    "S": "大峡谷",
                    "Order": 18
                },
                {
                    "I": "EAN_178296",
                    "S": "渥太华",
                    "Order": 19
                }
            ]
        },
        {
            "S": "欧洲",
            "Order": 3,
            "Items": [
                {
                    "I": "EAN_179898",
                    "S": "巴黎",
                    "Order": 1
                },
                {
                    "I": "EAN_179899",
                    "S": "罗马",
                    "Order": 2
                },
                {
                    "I": "EAN_178279",
                    "S": "伦敦",
                    "Order": 3
                },
                {
                    "I": "EAN_177970",
                    "S": "圣托里尼",
                    "Order": 4
                },
                {
                    "I": "EAN_179992",
                    "S": "巴塞罗那",
                    "Order": 5
                },
                {
                    "I": "EAN_1222",
                    "S": "佛罗伦萨",
                    "Order": 6
                },
                {
                    "I": "EAN_179896",
                    "S": "慕尼黑",
                    "Order": 7
                },
                {
                    "I": "EAN_179981",
                    "S": "威尼斯",
                    "Order": 8
                },
                {
                    "I": "EAN_180012",
                    "S": "米兰",
                    "Order": 9
                },
                {
                    "I": "EAN_180014",
                    "S": "布拉格",
                    "Order": 10
                },
                {
                    "I": "EAN_178231",
                    "S": "雅典",
                    "Order": 11
                },
                {
                    "I": "EAN_180102",
                    "S": "尼斯",
                    "Order": 12
                },
                {
                    "I": "EAN_179894",
                    "S": "法兰克福",
                    "Order": 13
                },
                {
                    "I": "EAN_179892",
                    "S": "柏林",
                    "Order": 14
                },
                {
                    "I": "EAN_178316",
                    "S": "维也纳",
                    "Order": 15
                },
                {
                    "I": "EAN_178229",
                    "S": "阿姆斯特丹",
                    "Order": 16
                },
                {
                    "I": "EAN_178281",
                    "S": "马德里",
                    "Order": 17
                },
                {
                    "I": "EAN_6069845",
                    "S": "爱丁堡",
                    "Order": 18
                },
                {
                    "I": "EAN_178289",
                    "S": "莫斯科",
                    "Order": 19
                },
                {
                    "I": "EAN_179994",
                    "S": "布达佩斯",
                    "Order": 20
                },
                {
                    "I": "EAN_6341134",
                    "S": "费特希耶",
                    "Order": 21
                },
                {
                    "I": "EAN_178252",
                    "S": "哥本哈根",
                    "Order": 22
                },
                {
                    "I": "EAN_553248635358954983",
                    "S": "苏黎世",
                    "Order": 23
                },
                {
                    "I": "EAN_180029",
                    "S": "圣彼得堡",
                    "Order": 24
                }
            ]
        },
        {
            "S": "大洋洲",
            "Order": 4,
            "Items": [
                {
                    "I": "EAN_178312",
                    "S": "悉尼",
                    "Order": 1
                },
                {
                    "I": "EAN_178283",
                    "S": "墨尔本",
                    "Order": 2
                },
                {
                    "I": "EAN_179993",
                    "S": "布里斯班",
                    "Order": 3
                },
                {
                    "I": "EAN_6049663",
                    "S": "堪培拉",
                    "Order": 4
                },
                {
                    "I": "EAN_141",
                    "S": "帕劳",
                    "Order": 5
                },
                {
                    "I": "EAN_180018",
                    "S": "皇后镇",
                    "Order": 6
                },
                {
                    "I": "EAN_178233",
                    "S": "奥克兰",
                    "Order": 7
                },
                {
                    "I": "EAN_180064",
                    "S": "黄金海岸",
                    "Order": 8
                },
                {
                    "I": "EAN_70",
                    "S": "关岛",
                    "Order": 9
                },
                {
                    "I": "EAN_179996",
                    "S": "基督城",
                    "Order": 10
                },
                {
                    "I": "EAN_553248635404168639",
                    "S": "凯恩斯",
                    "Order": 11
                },
                {
                    "I": "EAN_6051330",
                    "S": "阿德莱德",
                    "Order": 12
                },
                {
                    "I": "EAN_6127327",
                    "S": "惠灵顿",
                    "Order": 13
                },
                {
                    "I": "EAN_6142849",
                    "S": "塞班岛",
                    "Order": 14
                }
            ]
        },
        {
            "S": "其他地区",
            "Order": 5,
            "Items": [
                {
                    "I": "EAN_553248635974547388",
                    "S": "迪拜",
                    "Order": 1
                },
                {
                    "I": "EAN_115",
                    "S": "毛里求斯岛",
                    "Order": 2
                },
                {
                    "I": "EAN_453",
                    "S": "阿布扎比",
                    "Order": 3
                }
            ]
        }
]

var cnCity=[{
		"I": "3201",
		"S": "香港",
		"Order": 1
	}, {
		"I": "3301",
		"S": "澳门",
		"Order": 2
	}, {
		"I": "0101",
		"S": "北京",
		"Order": 3
	}, {
		"I": "0201",
		"S": "上海",
		"Order": 4
	}, {
		"I": "2001",
		"S": "广州",
		"Order": 5
	}, {
		"I": "2003",
		"S": "深圳",
		"Order": 6
	}, {
		"I": "1201",
		"S": "杭州",
		"Order": 7
	}, {
		"I": "2301",
		"S": "成都",
		"Order": 8
	}, {
		"I": "1401",
		"S": "厦门",
		"Order": 9
	}, {
		"I": "2201",
		"S": "三亚",
		"Order": 10
	}, {
		"I": "1801",
		"S": "武汉",
		"Order": 11
	}, {
		"I": "2701",
		"S": "西安",
		"Order": 12
	}, {
		"I": "2004",
		"S": "珠海",
		"Order": 13
	}]

module.exports = {
	frCity:frCity,
	cnCity:cnCity,
} 







// WEBPACK FOOTER //
// ./src/components/common/city.js